import { type FC } from "react";

import { LLMLogo, ChatGPTLogo } from "@/components/icons";
import { ChildCard, ComingSoonCard } from "@/components/molecules/ChildCard";

/**
 * **LLMApp**
 *
 * Zwischenebene für LLM-Tools.
 * Zeigt verfügbare LLM-Integrationen an.
 *
 * @returns JSX element with LLM service cards
 *
 */
export const LLMApp: FC = () => {
  return (
    <div className="min-h-screen bg-background p-6 space-y-6 text-primary">
      <header className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <LLMLogo />
          <h1 className="text-2xl font-bold">LLM Services</h1>
        </div>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* ChatGPT Card */}
        <ChildCard
          ctaText="Start Chat"
          description="OpenAI's advanced language model for conversations, text generation, and AI assistance."
          icon={<ChatGPTLogo size="app" />}
          title="ChatGPT"
          to="/llm/chatgpt"
        />

        {/* Ollama Card */}
        <ChildCard
          ctaText="Local AI"
          description="Local AI models for private and secure conversations with models like Llama, Mistral, and more."
          icon={<LLMLogo />}
          title="Ollama"
          to="/llm/ollama"
        />

        {/* Future LLM Tools */}
        <ComingSoonCard
          description="Additional LLM providers and models will be available here."
          gradient={{ from: "from-purple-600", to: "to-purple-700" }}
          iconLetter="+"
          title="More Models"
        />
      </div>
    </div>
  );
};
